import { useTheme, type Theme } from '../state/ThemeContext';

const OPTIONS: { value: Theme; label: string }[] = [
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
  { value: 'auto', label: 'Auto' },
];

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  return (
    <div className="seg" role="group" aria-label="Téma">
      {OPTIONS.map((o) => (
        <button key={o.value} type="button" className={theme === o.value ? 'on' : ''} aria-pressed={theme === o.value} onClick={() => setTheme(o.value)}>
          {o.label}
        </button>
      ))}
    </div>
  );
}
